<template>
  <v-tab-item
    v-bind:key="index"
    v-bind:class="tabClass"
  >
    <slot />
  </v-tab-item>
</template>

<script>
export default {
  name: 'TabItem',
  props: {
    index: { required: true, type: [Number, Object] },
    /**
     * @description Значение аттрибута класса для вкладки.
     * @type {string}
     */
    tabClass: {
      default: () => '',
      required: false,
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
